export const environment = {
    production: true,
    hmr: false,

    // -----------------------------------------
    //      @ BACKEND
    // -----------------------------------------
    backEnd: 'https://staging-api.medray.net',

    // -----------------------------------------
    //      @ APP SECURITY
    // -----------------------------------------
    issuer: 'https://staging-auth.medray.net',
    clientId: 'medcilia-admin',
    scope: 'openid profile administration',
    redirectUri: 'https://staging-ams.medray.net/',
    silentRefreshRedirectUri: 'https://staging-ams.medray.net/silent-refresh.html',
    postLogoutRedirectUri: 'https://staging-ams.medray.net/',

    // -----------------------------------------
    //      @ GRAPGQL
    // -----------------------------------------
    GQL_SCHEMA_VERSION: '0.2'
};
